export default "__VITE_ASSET__VbF9S_tb__"